import { isPrimaryPointer } from './utils/is-primary-pointer.mjs';

function extractEventInfo(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"],
        },
    };
}
const wrapHandler = (handler, shouldFilterPrimaryPointer = false) => {
    const listener = (event) => handler(event, extractEventInfo(event));
    return shouldFilterPrimaryPointer
        ? (event) => isPrimaryPointer(event) && listener(event)
        : listener;
};

export { extractEventInfo, wrapHandler };
